export default "__VITE_ASSET__BOPCrO1J__"